import { FC, useState } from 'react';
import { Grid, TextField, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SCUIButton, SCUIDateRanger } from '../../../../atomic/atoms';
import { SCUIGeneralDrawerHeader } from '../../../../atomic/molecules';
import CargoFeeManagementCommand from '../../../../services/command/cargoFeeManagement/CargoFeeManagementCommand.services';
import Swal from 'sweetalert2';
import moment from 'moment';
import { CFM, cfmCls } from '../../cargoFeeManagement.classes';

interface IProps {
    selectedRow?: any;
    setSelectedRow?: any;
    onClose?: any;
    refresh?: any;
}
export const SCUICargoFeeEdit: FC<IProps> = ({ selectedRow, setSelectedRow, onClose, refresh }) => {
    const { t } = useTranslation();
    const [price, setPrice] = useState();
    const [desi, setDesi] = useState();
    const [endDate, setEndDate] = useState('');
    const [createdDate, setCreatedDate] = useState('');

    const isActive = undefined;

    const _handleChangeDate = (event: any) => {
        setCreatedDate(event[0]);
        setEndDate(event[1]);
    };

    const UpdateCargoOrderLimit = async () => {
        if (Number(price) < 0) {
            Swal.fire(t('general.error'), t('cargoFeeManagement.priceCanNotBeNegative'), 'error');
            return;
        }

        let updateCargoFeeRequests = selectedRow.map((row: any) => {
            return {
                id: row.shippingCompanyPriceId,
                shippingCompanyId: row.shippingCompanyId,
                distanceTypeId: row.distanceTypeId,
                departureLocationTypeId: row.departureLocationTypeId,
                price: price,
                validStartDate: createdDate,
                validEndDate: endDate,
                desi: selectedRow.length > 1 ? row.desi : desi,
                isActive: isActive,
            };
        });
        CargoFeeManagementCommand.UpdateCargoFee(updateCargoFeeRequests)
            .then(() => {
                Swal.fire(t('general.updated'), ' ', 'success');
                refresh();
                onClose();
                setSelectedRow([]);
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            })
            .finally(() => {});
    };
    return (
        <form
            onSubmit={(e: any) => {
                e.preventDefault();
            }}
        >
            <div className={cfmCls('commentFilterContainer', CFM.drawerEdit)}>
                {selectedRow && selectedRow.length > 0 && (
                    <Grid container spacing={2}>
                        <SCUIGeneralDrawerHeader header={t('cargoFeeManagement.cargoFeeEdit')} onClose={onClose} />
                        <Grid
                            size={{
                                xs: 12,
                                md: 12,
                                lg: 12,
                                xl: 12,
                            }}
                        >
                            <Grid
                                style={{ marginTop: '1rem' }}
                                size={{
                                    xs: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12,
                                }}
                            >
                                <Tooltip
                                    title={
                                        selectedRow &&
                                        selectedRow
                                            .map((item: any) => item.shippingCompanyName)
                                            .filter(
                                                (value: any, index: any, self: any) => self.indexOf(value) === index
                                            )
                                            .join(', ')
                                    }
                                    placement="top"
                                >
                                    <TextField
                                        label={t('cargoFeeManagement.shippingCompanyName')}
                                        defaultValue={
                                            selectedRow &&
                                            selectedRow
                                                .map((item: any) => item.shippingCompanyName)
                                                .filter(
                                                    (value: any, index: any, self: any) => self.indexOf(value) === index
                                                )
                                                .join(', ')
                                        }
                                        variant="outlined"
                                        type="text"
                                        id="shippingCompanyName"
                                        fullWidth
                                        disabled
                                        className={cfmCls(CFM.input, CFM.inputTextfield, CFM.fieldEditShippingCompany)}
                                    />
                                </Tooltip>
                            </Grid>
                            <Grid
                                style={{ marginTop: '2rem' }}
                                size={{
                                    xs: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12,
                                }}
                            >
                                <Tooltip
                                    title={
                                        selectedRow &&
                                        selectedRow
                                            .map((item: any) => item.countyName)
                                            .filter(
                                                (value: any, index: any, self: any) => self.indexOf(value) === index
                                            )
                                            .join(', ')
                                    }
                                    placement="top"
                                >
                                    <TextField
                                        label={t('cargoFeeManagement.distanceTypeName')}
                                        id="distanceTypeName"
                                        defaultValue={
                                            selectedRow &&
                                            selectedRow
                                                .map((item: any) => item.distanceTypeName)
                                                .filter(
                                                    (value: any, index: any, self: any) => self.indexOf(value) === index
                                                )
                                                .join(', ')
                                        }
                                        type="text"
                                        variant="outlined"
                                        fullWidth
                                        disabled
                                        className={cfmCls(CFM.input, CFM.inputTextfield, CFM.fieldEditDistanceType)}
                                    />
                                </Tooltip>
                            </Grid>
                            {selectedRow.length == 1 && (
                                <Grid
                                    style={{ marginTop: '2rem' }}
                                    size={{
                                        xs: 12,
                                        md: 12,
                                        lg: 12,
                                        xl: 12,
                                    }}
                                >
                                    <TextField
                                        id="desi"
                                        defaultValue={selectedRow.length == 1 ? selectedRow[0].desi : ''}
                                        type="text"
                                        label={t('cargoFeeManagement.desi')}
                                        fullWidth
                                        className={cfmCls(CFM.input, CFM.inputTextfield, CFM.fieldEditDesi)}
                                        onChange={(event: any) => {
                                            setDesi(event.target.value);
                                        }}
                                    />
                                </Grid>
                            )}
                            <Grid
                                style={{ marginTop: '2rem' }}
                                size={{
                                    xs: 12,
                                    md: 12,
                                    lg: 12,
                                    xl: 12,
                                }}
                            >
                                <TextField
                                    id="price"
                                    defaultValue={selectedRow.length == 1 ? selectedRow[0].price : ''}
                                    type="text"
                                    label={t('cargoFeeManagement.price')}
                                    fullWidth
                                    className={cfmCls(CFM.input, CFM.inputTextfield, CFM.fieldEditPrice)}
                                    onChange={(event: any) => {
                                        setPrice(event.target.value);
                                    }}
                                />
                            </Grid>
                            <Grid style={{ marginTop: '2rem' }} className={CFM.drawerEditDateRange}>
                                <SCUIDateRanger
                                    fromDate={
                                        selectedRow.length == 1
                                            ? moment(selectedRow[0].validStartDate).format('YYYY/MM/DD')
                                            : ''
                                    }
                                    toDate={
                                        selectedRow.length == 1
                                            ? moment(selectedRow[0].validEndDate).format('YYYY/MM/DD')
                                            : ''
                                    }
                                    setDateRange={_handleChangeDate}
                                    dateFormat="YYYY-MM-DD"
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                        <Grid
                            className={CFM.drawerEditActions}
                            style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                            }}
                            size={{
                                xs: 12,
                                md: 12,
                                lg: 12,
                                xl: 12,
                            }}
                        >
                            <SCUIButton
                                text={t('general.update')}
                                type="primary"
                                sizeType="default"
                                buttonType="submit"
                                size={'m'}
                                style={{ width: 140 }}
                                className={cfmCls(CFM.input, CFM.inputButton, CFM.btnDrawerEditSubmit)}
                                onClick={UpdateCargoOrderLimit}
                            />
                        </Grid>
                    </Grid>
                )}
            </div>
        </form>
    );
};
